export const splitDigits = (code: number) => {
  const digitsArray = String(code).split('').map(Number)

  const result: { [key: string]: string } = {}

  digitsArray.forEach((digit, index) => {
    const key = `val${index + 1}`
    result[key as keyof typeof result] = String(digit)
  })
  return result
}
